export const props = { viewBox: "0 0 20 15" };
export const innerHTML = `<path fill-rule="evenodd" clip-rule="evenodd" d="M18.5938 0H1.40625C0.628906 0 0 0.628906 0 1.40625V13.5938C0 14.3711 0.628906 15 1.40625 15H18.5938C19.3711 15 20 14.3711 20 13.5938V1.40625C20 0.628906 19.3711 0 18.5938 0ZM18.5938 4.21875H1.40625V1.40625H18.5938V4.21875ZM1.40625 13.5H18.5938V5H1.40625V13.5Z"/>
<path d="M9 10H3V6H9V10Z"/>
<path d="M9 13.5H3V12H9V13.5Z"/>
<path d="M17 10H11V6H17V10Z"/>
<path d="M17 13.5H11V12H17V13.5Z"/>`
